import { Component, Input} from '@angular/core';
@Component({
    selector: 'kh-settings-menu',
    styleUrls: ['./settings-menu.component.less'],
    templateUrl: './settings-menu.component.html',
    standalone: false
})
export class SettingsMenuComponent {
  @Input() public label = '';
  @Input() public value = '';
  @Input() public menuLabel = 'Menu';
}
